import styled, { keyframes } from "styled-components";

import { Text, Flex } from "@similarweb/ui-components/foundations";

const slideInDown = keyframes`
    from {
        transform: translateY(-120%);
    }

    to {
        transform: translateY(0)
    }
`;

const StyledText = styled(Text)`
    display: block;
    margin: 8px 0 20px;
`;

const StyledFormContainer = styled.div`
    padding-bottom: 200px;
`;

export const StyledGradientButtonWrapper = styled(Flex)`
    margin-bottom: 10px;
    animation: ${slideInDown} 500ms ease-in forwards;
`;
